<template>
  <CCol style="margin-top: 25px">
    <CRow alignHorizontal="center">
      <CCol sm="6" />
      <CCol sm="6" class="d-flex justify-content-around">
        <template v-if="selected == 'owner'">
          <div class="button button-green">Set as Owner</div>
        </template>
        <template v-if="selected == 'admin'">
          <div class="button button-green">Set as Admin</div>
        </template>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <h4>Manage Role</h4>
      </CCol>
      <CCol sm="6" />
    </CRow>
    <CRow>
      <CCol sm="6" />
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">View Only</CCol>
          <CCol class="d-flex justify-content-center">Editable</CCol>
          <CCol class="d-flex justify-content-center">Disable</CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h4>Course Management</h4>
      </CCol>
      <CCol sm="6" />
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>Course Record Overview</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="courseRecordOverview" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="courseRecordOverview" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="courseRecordOverview" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>Create Course</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="createCourse" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="createCourse" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="createCourse" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h4>Examination</h4>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="examination" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="examination" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="examination" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h4>Report and Export</h4>
      </CCol>
      <CCol sm="6" />
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>Course</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="course" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="course" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="course" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>User</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="user" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="user" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="user" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>Income</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="income" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="income" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="income" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>Score</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="score" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="score" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="score" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h4>Report and Export</h4>
      </CCol>
      <CCol sm="6" />
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>Course Analytics</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="courseAnalytics" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="courseAnalytics" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="courseAnalytics" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <h6>User Analytics</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="userAnalytics" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="userAnalytics" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="userAnalytics" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow style="margin-bottom: 2%">
      <CCol sm="6">
        <h6>Owner Analytics</h6>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="ViewOnly" v-model="ownerAnalytics" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Editable" v-model="ownerAnalytics" />
          </CCol>
          <CCol class="d-flex justify-content-center">
            <input type="radio" id="one" value="Disable" v-model="ownerAnalytics" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow alignHorizontal="around">
      <div class="button button-grey" @click="setModalVisible()">CANCEL</div>
      <div class="button button-blue">UPDATE</div>
    </CRow>
  </CCol>
</template>

<script>
export default {
  name: "manageRole",
  props: {
    selected: String,
    setModalVisible: Function
  },
  data() {
    return {
      courseRecordOverview: "Editable",
      createCourse: "Editable",
      examination: "Editable",
      course: "ViewOnly",
      user: "ViewOnly",
      income: "ViewOnly",
      score: "ViewOnly",
      courseAnalytics: "Editable",
      userAnalytics: "Editable",
      ownerAnalytics: "Editable"
    };
  }
};
</script>
